import React, { Component } from 'react';
import './BankSuccess.scss';
import { PATH_LINK } from '../AddBank/AddBank';
import Template from '../BankFailure/Template/Template';
import Loader from '../../Shared/Loader/Loader';
import { BANK_FAILURE, FAILED, INIT, MANUAL } from '../../../settings/settings';
import checkMark from '../../../assets/images/Subtract.svg';

export class BankSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started: true,
    };
    this.nextStepHandler = this.nextStepHandler.bind(this);
  }

  componentDidMount() {
    const {
      dispatchPageLoad,
      actions: { getExistingBanks },
      path,
    } = this.props;
    dispatchPageLoad(
      path === PATH_LINK ? 'BankSuccessPlaid' : 'BankSuccessManual'
    );
    getExistingBanks();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      linkedBanks: { addBankLoading, addBankStatus },
      setBankProgress,
    } = this.props;
    if (
      (addBankLoading || addBankStatus === INIT) &&
      nextProps.linkedBanks.addBankStatus === FAILED
    ) {
      setBankProgress(BANK_FAILURE);
    }
  }

  nextStepHandler() {
    const { handleClose, markComplete } = this.props;
    markComplete(true);
    handleClose();
  }

  render() {
    const {
      path,
      handleClose,
      existingBanks: { fetchingAccounts },
      linkedBanks: { addBankLoading },
      isSalesforceRep,
    } = this.props;
    const isManualPath = path === MANUAL;
    const loading = fetchingAccounts || addBankLoading;
    return (
      <div>
        {loading && (
          <div className="bank-success-loader-container">
            <div className="bank-success-loading-text">
              Syncing your accounts...
            </div>
            <Loader innerClassName="bank-success-loader" isVisible />
          </div>
        )}
        {!loading && (
          <div>
            {isManualPath && isSalesforceRep && (
              <Template
                image={checkMark}
                header={'Success'}
                hasPDF={false}
                msg={
                  <div>
                    This bank will be linked to all eligible funds and is
                    available to use for purchases immediately.
                    <br></br>
                    <br></br>
                    To maintain this bank for future transactions, check your
                    email for next steps.
                    <br></br>
                    <br></br>
                    Redemptions to this bank account must wait 5 business days.
                  </div>
                }
              />
            )}
            {isManualPath && !isSalesforceRep && (
              <Template
                image={checkMark}
                header={'Success'}
                msg={
                  <div>
                    This bank will be linked to all eligible funds and is
                    available to use for purchases immediately.
                    <br></br>
                    <br></br>
                    To maintain this bank for future transactions, check your
                    email for next steps.
                    <br></br>
                    <br></br>
                    Redemptions to this bank account must wait 5 business days.
                  </div>
                }
                nextButtonID={'ManualSuccess'}
                nextButton={'Done'}
                onNextClick={() => handleClose()}
                nextDestination={''}
                textOffRamp={' '}
              />
            )}
            {!isManualPath && (
              <Template
                image={checkMark}
                header={'Success'}
                msg={
                  <div>
                    This bank will be linked to all <sup>*</sup>eligible funds,
                    and is <p>available to use for purchases immediately.</p>
                    <br></br>
                    <br></br>
                    Redemptions to this bank account must wait 5 business days.
                    <br />
                    <br />
                    <div className="bank-success-italics">
                      <sup>*</sup>Some associations of banks to eligible funds
                      may take 2-3 business days.
                    </div>
                  </div>
                }
                nextButtonID={'PlaidSuccess'}
                nextButton={'Done'}
                onNextClick={() => handleClose()}
                nextDestination={''}
                textOffRamp={' '}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default BankSuccess;
